var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueApexCharts',{attrs:{"type":"bar","options":_vm.barData.options,"series":_vm.barData.series,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }